<template>
  <div class="shop" v-loading="loading">
    <div class="top">
      <el-date-picker
        v-model="form.s_month"
        type="month"
        style="width: 136px; margin-right: 10px"
        value-format="yyyy-MM"
        size="mini"
        placeholder="开始时间"
      >
      </el-date-picker>
      <el-date-picker
        v-model="form.e_month"
        type="month"
        style="width: 136px; margin-right: 10px;"
        value-format="yyyy-MM"
        size="mini"
        placeholder="结束时间"
      >
      </el-date-picker>

      <el-button class="search" size="small" type="primary" @click="searchList"
        >搜索</el-button
      >
    </div>
    <el-table
      :data="tableData"
      max-height="720"
      :cell-style="tc"
      :header-cell-style="tccolor"
    >
      <el-table-column label="月份" prop="month"></el-table-column>
      <el-table-column
        label="月初用户红包总额"
        prop="s_user_red_packet"
      ></el-table-column>
      <el-table-column
        label="此月平台发出红包总额"
        prop="send_red_packet"
      ></el-table-column>
      <el-table-column
        label="此月平台回收红包总额"
        prop="reclaim_red_packet"
      ></el-table-column>
      <el-table-column
        label="月末用户红包总额"
        prop="e_user_red_packet"
      ></el-table-column>
    </el-table>
    <el-col :span="24">
      <div class="pagination">
        <el-pagination
          background
          @current-change="pageChange"
          :current-page="form.page"
          :page-size="form.size"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-col>
  </div>
</template>

<script>
import { RedPacketStatistics } from '@/api/redpacket'
export default {
  components: {},
  data() {
    return {
      loading: false,
      state: '',
      form: {
        month: '',
        s_month: '',
        e_month: '',
        page: 1,
        size: 10
      },
      tableData: [],
      total: 0
    }
  },
  mounted() {
    this.getBoxList()
  },
  methods: {
    //获取列表数据
    async getBoxList() {
      let { s_month, e_month, page, size } = this.form
      let url = `s_month=${s_month}&e_month=${e_month}&page=${page}&size=${size}`
      let res = await RedPacketStatistics(url)
      console.log(res)
      if (res.code === 10000) {
        this.total = res.data.total
        this.tableData = res.data.data
      } else {
        this.$message.error(res.message)
      }
    },

    //搜索
    searchList() {
      this.form.page = 1
      this.getBoxList()
    },

    // 分页设置
    pageChange(page) {
      this.form.page = page
      //获取更多数据
      this.getBoxList()
    },

    tc() {
      return 'text-align:center; color:#333333; font-size:12px;'
    },
    tccolor() {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
    }
  }
}
</script>
<style lang="scss" scoped>
.el-date-editor,
.el-input {
  margin-bottom: 10px;
}
.shop {
  padding: 20px;
  .pagination {
    float: right;
    margin-top: 12px;
  }
  .top {
    margin-bottom: 20px;
    .input {
      width: 150px;
      margin-right: 10px;
    }
  }
  .align {
    text-align: center;
    .sure {
      width: 200px;
    }
  }
  .promoter-con {
    padding: 30px;
  }
  .activation-con {
    padding: 30px;
  }
  ::v-deep.dialog {
    .title {
      text-align: center;
      font-weight: bold;
      font-size: 20px;
    }
  }
  .export-window {
    display: flex;
    justify-content: space-evenly;
    margin-top: 30px;
    margin-bottom: 25px;
  }
}
</style>
